import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AccessDenied.scss';

const AccessDenied = ({ message, type = 'board' }) => {
    const navigate = useNavigate();

    const getTitle = () => {
        switch (type) {
            case 'board':
                return 'Board Access Denied';
            case 'card':
                return 'Card Access Denied';
            case 'workspace':
                return 'Workspace Access Denied';
            case 'billing':
                return 'Billing Access Denied';
            default:
                return 'Access Denied';
        }
    };

    const getDefaultMessage = () => {
        switch (type) {
            case 'board':
                return 'You do not have permission to access this board. It may be private or you may need to request access from the board owner.';
            case 'card':
                return 'You do not have permission to access this card. It may be on a private board or you may need to request access.';
            case 'workspace':
                return 'You do not have permission to access this workspace. Please contact the workspace administrator.';
            case 'billing':
                return 'Only workspace administrators can access billing and subscription management. Please contact your workspace admin if you need to make changes to the subscription.';
            default:
                return 'You do not have permission to access this resource.';
        }
    };

    return (
        <div className="access-denied-container">
            <div className="access-denied-content">
                <div className="access-denied-icon">
                    <span className="material-symbols-outlined">lock</span>
                </div>
                <h1 className="access-denied-title">{getTitle()}</h1>
                <p className="access-denied-message">
                    {message || getDefaultMessage()}
                </p>
                <div className="access-denied-actions">
                    <button 
                        className="btn-primary" 
                        onClick={() => navigate('/boards')}
                    >
                        <span className="material-symbols-outlined">dashboard</span>
                        Go to My Boards
                    </button>
                    <button 
                        className="btn-secondary" 
                        onClick={() => navigate(-1)}
                    >
                        <span className="material-symbols-outlined">arrow_back</span>
                        Go Back
                    </button>
                </div>
                <div className="access-denied-help">
                    <p>Need access to this {type}?</p>
                    <ul>
                        <li>Contact the {type} owner or administrator</li>
                        <li>Request an invitation to join</li>
                        <li>Check if you're logged in with the correct account</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AccessDenied;

